<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="calibre_pb_0">
<p class="calibre3"><span id="Page_v" title="v"></span></p>
<h2 class="nobreak" id="toclink_v">PREFACE</h2>
<p class="drop-cap pcalibre"><span class="smcap">All</span> save one of the papers here collected were
written as lectures and read from a desk at
Cambridge; the exception being that upon Trollope,
contributed to <i class="calibre11">The Nation and the Athenaeum</i> and
pleasantly provoked by a recent edition of the “Barsetshire”
novels. To these it almost wholly confines
itself. But a full estimate of Trollope as one of our
greatest English novelists—and perhaps the raciest of
them all—is long overdue, awaiting a complete edition
of him. His bulk is a part of his quality: it can no more
be separated from the man than can Falstaff’s belly
from Falstaff. He will certainly come to his own
some day, but this implies his coming with all his
merits and all his defects: and this again cannot happen
until some publisher shows enterprise. The expensive
and artificial vogue of the three-volume-novel did wonders
for Trollope in one generation, to kill him for
another: since no critic can talk usefully about books
to many of which his hearers have no access. But we
shall see Trollope reanimated.</p>
<p class="calibre3">The papers on Dickens and Thackeray attempt
judgment on them as full novelists. Those on Disraeli
and Mrs. Gaskell merely take a theme, and try to
show how one theme, taking possession, will work upon
two very different minds. Much more could have
been said generally upon both authors, and generically
upon the “idea” of a novel.</p>
<p class="calibre3"><span id="Page_vi" title="vi"></span></p>
<p class="calibre3">As usual, with a few corrections, I leave these lectures
as they were written and given, at intervals and
for their purpose. They abound therefore with repetitions
and reminders which the reader must try to
forgive.</p>
<p class="right">
ARTHUR QUILLER-COUCH.
</p>
<p class="calibre3">January 5, 1925.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?393a47e1